// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ZoomHover: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 21"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="20"
            height="21"
            fill="currentColor"
        >
            <path
                d="M412.542968,422.832032 L407.867187,418.15625 C408.930468,416.577734 409.455077,414.605469 409.174217,412.503906 C408.696483,408.927734 405.764843,406.019531 402.185936,405.566407 C396.865624,404.892968 392.392968,409.366405 393.068749,414.683593 C393.521874,418.263281 396.430859,421.195312 400.00625,421.671875 C402.108203,421.952774 404.080468,421.428321 405.658594,420.364844 L410.334376,425.040625 C410.944532,425.650781 411.933986,425.650781 412.544142,425.040637 C413.152345,424.433594 413.152345,423.441406 412.542969,422.832032 L412.542968,422.832032 Z M404.250001,414.5625 L402.027345,414.5625 L402.027345,416.75 C402.027345,417.267969 401.607813,417.6875 401.125001,417.6875 C400.605469,417.6875 400.187501,417.269531 400.187501,416.75 L400.187501,414.5625 L397.964844,414.5625 C397.480469,414.5625 397.0625,414.144531 397.0625,413.625 C397.0625,413.105469 397.482031,412.6875 397.964844,412.6875 L400.187501,412.6875 L400.187501,410.5 C400.187501,409.982031 400.607032,409.5625 401.089845,409.5625 C401.572657,409.5625 402.027345,409.980469 402.027345,410.5 L402.027345,412.6875 L404.214845,412.6875 C404.769531,412.6875 405.187501,413.105469 405.187501,413.625 C405.187501,414.144531 404.769531,414.5625 404.250001,414.5625 Z"
                transform="translate(-393 -405)"
            />
        </svg>
    );
};

export default React.memo(ZoomHover);
